'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.set = set;
exports.clear = clear;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET = 'hotelInformation/SET';
var CLEAR = 'hotelInformation/CLEAR';

var initialState = {
  // errors: [
  //   {
  //     code: 'param_required',
  //     field: 'subdivision'
  //   },
  //   {
  //     code: 'param_invalid',
  //     field: 'subdivision',
  //     message: ''
  //   },
  //   {
  //     code: 'xxx',
  //     title: 'xxx',
  //     message: ''
  //   }
  // ]
  errors: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET:
      return (0, _extends3.default)({}, initialState, action.hotelInformation);
    case CLEAR:
      return (0, _extends3.default)({}, initialState);
    default:
      return state;
  }
}

function set(hotelInformation) {
  return {
    type: SET,
    hotelInformation: hotelInformation
  };
}

function clear() {
  return {
    type: CLEAR
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/hotelInformation.js
// module id = 588
// module chunks = 0